import { useState, useEffect } from 'react'
import { useDisclosure, useMediaQuery } from '@mantine/hooks';

import { Drawer, Stack, Button, Image, Title, Space, Text, UnstyledButton, Center, Loader, Modal } from '@mantine/core';
import Offers from './components/Offers';

function App() {

  const shop_url = "https://aikidosteel.com"
  const googleOptimizeExperimentId = ""
  const [experimentVariant, setExperimentVariant] = useState('')
  const [count, setCount] = useState(0)
  const [chosenProduct, setChosenProduct] = useState(null)
  const [loadingOffer, setLoadingOffer] = useState(false)
  const [justGoToCart, setJustGoToCart] = useState(false)
  
  const [opened, { open, close }] = useDisclosure(false);

  const isMobile = useMediaQuery('(max-width: 600px)');
  const isLargeMobile = useMediaQuery('(max-width: 900px)');

  const isDevelopment = () => {
    return !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
  }
    
  const handleAddToCart = (product, mobile) => {
    setChosenProduct(product)
    setLoadingOffer(true)
    if (!isDevelopment()) {
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'Promotion',
        eventAction: 'Accept - ' + product.shortTitle + ' - ' + (mobile ? 'Mobile' : "Desktop"),
        eventLabel: `Yoki/Horudo BS Popup - ${googleOptimizeExperimentId} - ${experimentVariant}`
      });
    } 
    setTimeout(() => {
      window.location = `${shop_url}/cart/add/` + product.variantId
    }, 1000)
    
  }

  const handleJustGoToCart = (mobile) => {
    setJustGoToCart(true)
    setLoadingOffer(false)
    if (!isDevelopment()) {
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'Promotion',
        eventAction: 'Reject - ' + (mobile ? 'Mobile' : "Desktop"),
        eventLabel: `Yoki/Horudo BS Popup - ${googleOptimizeExperimentId} - ${experimentVariant}`
      });
    }
    setTimeout(() => {
      window.location = `${shop_url}/cart`
    }, 1000)

  }

  const getCookieIHReact = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

  const addAddToCartEventListeners = () => {

    if ((!process.env.NODE_ENV || process.env.NODE_ENV === 'production') && getCookieIHReact('ref') !== '965643PBDD20231010EM1' && !(getCookieIHReact('ref') === '967634BF20231123EM1')) {

      window.addEventListener('load', function() {
    
        // Trigger popup on Add to Cart button 1
        document.querySelectorAll('[data-add-to-cart]')[0].addEventListener('click', open);
        
        // Trigger popup on Add to Cart button 2
        document.querySelectorAll('[data-add-to-cart]')[1].addEventListener('click', open);
    
      });
    }
  }

  const [offerList, setOfferList] = useState([
    /*{
      imageSrc: "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/Suji.png?v=1734059082",
      title: "Suji Cleaver",
      shortTitle: "Suji",
      link: "https://aikidosteel.com/products/aikido-suji-knife?variant=32090792788039",
      variantId: 32090792788039,
      offerPrice: 0,
      regularPrice: 119.95,
    },*/
    {
      imageSrc: "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/Hokkan_Yoki_b3fe56e5-a56c-4cb9-9564-897604fa720d.png?v=1700345724",
      title: "Yoki Knife Holder",
      shortTitle: "Yoki",
      link: "https://aikidosteel.com/products/aikido-knife-holder",
      variantId: 32090905149511,
      offerPrice: 0,
      regularPrice: 69.95
    },
    {
      imageSrc: "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/Hokkan_Horudo.png?v=1700345724",
      title: "Horudo Magnetic Knife Holder",
      shortTitle: "Horudo",
      link: "https://aikidosteel.com/collections/kitchen-accessories/products/horudo-acacia-magnetic-knife-holder",
      variantId: 32326432489543,
      offerPrice: 25.99,
      regularPrice: 129.95
    }
  ])

  const [offerTitle, setOfferTitle] = useState('Choose a discounted gift to complete your knife set!')
  //const [offerTitle, setOfferTitle] = useState('Complete Your Knife Set with a Discounted Holder!')

  useEffect(()=> {
    const tempExperimentVariant = window.google_optimize ? window.google_optimize.get(googleOptimizeExperimentId) : "n/a"
    setExperimentVariant(tempExperimentVariant)

  }, [window.google_optimize])

  addAddToCartEventListeners()

  useEffect(()=> {
    if(opened && !isDevelopment()) {
      window.ga('send', {hitType: 'event',
        eventCategory: 'Promotion',
        eventAction: 'Show - ' + (isLargeMobile ? 'Mobile' : "Desktop"),
        eventLabel: `Yoki/Horudo BS Popup - ${googleOptimizeExperimentId} - ${experimentVariant}`
      });
    }
  }, [opened])

  return (
    <div>

      {!process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? <Button onClick={open}>Add to Cart</Button> : null}

      <Drawer style={{position: "absolute", zIndex: 10000}} transitionProps={{ duration: 750 }} title={loadingOffer || justGoToCart ? null : <Title align="center" order={isMobile ? 3 : 2} style={{fontFamily: "Oswald", letterSpacing: "1.6px", color: "#ffe27b", fontWeight: 500, fontSize: "1.175rem"}}>SPECIAL OFFER</Title>} styles={{close: {marginLeft: "0px"}, title: {margin: "auto", paddingLeft: "18px"}, header: {background: "black", color: "white"}}} size={isMobile ? "100%" : "550px"} position={"top"} opened={opened} onClose={close} overlayProps={{ opacity: 0.5, blur: 4 }} withCloseButton={!(loadingOffer || justGoToCart)}>

        {!loadingOffer && !justGoToCart ?
          <>
            <Title mt={20} align="center" style={{fontFamily: "Roboto", letterSpacing: "-0.195px", fontSize: "1.525rem", lineHeight: "1.25"}}>{offerTitle}</Title>
            <Space h={"xl"}></Space>
            <Offers googleOptimizeExperimentId={googleOptimizeExperimentId} experimentVariant={experimentVariant} offerList={offerList} handleAddToCart={handleAddToCart}></Offers>
            <Center>
              <UnstyledButton onClick={() => {handleJustGoToCart(isLargeMobile)}} mt={isMobile ? 20 : 30} style={{textDecoration: "underline"}}>NO THANKS, GO TO MY CART</UnstyledButton>
            </Center>
          </>
        :
          loadingOffer && !justGoToCart ?
            <>
              <Center h={400}>
                <Stack align={"center"}>
                  <Image height={150} mx="auto" fit="contain" src={chosenProduct.imageSrc}></Image>
                  <Title align="center" order={1} style={{fontFamily: "Bebas Neue"}}>Adding your offer</Title>
                  <Loader variant='dots'></Loader>
                </Stack>
                
              </Center>
            </>
          :
            <>
              <Center h={400}>
                <Stack align={"center"}>
                
                  <Title align="center" order={1} style={{fontFamily: "Bebas Neue"}}>Loading your cart</Title>
                  <Loader variant='dots'></Loader>
                  
                </Stack>
                
              </Center>
            </>
        }
      </Drawer>
    </div>
  )
}

export default App
